import React from "react";
import challenge from "../../../assets/img/gallery/delivery-man-2.png";
import bgShape from "../../../assets/img/banner/hero_bg.jpg";

const Challenge = () => {
  return (
    <>
      <section
        className="challengeSec p-30"
        style={{
          backgroundImage: `url(${bgShape})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="challengeCard">
                <div className="text">
                  <p>For the EHL Life Sciences Pvt Ltd you don't yet know.</p>
                  <span>
                    If you use this site regularly and would like to help keep
                    the site on the Internet, please consider donating a small
                    sum to help pay for the hosting and bandwidth bill.
                  </span>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="challengeCard">
                <div className="img">
                  <img src={challenge} alt="Challenge" className="img-fluid" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Challenge;
